import React, { useState, useEffect, useRef, useCallback } from 'react'
import Header from '../Header/Header.js'
import Handsontable from "handsontable";
import { HotTable } from '@handsontable/react-wrapper';
import { getData, deleteData, putFile, postFile } from '../../FetchApiServices.js';
import Loader from '../Assets/Loader.js';
import FormModal from '../Forms/FormModal.js';
import ConfirmationModal from '../Assets/ConfirmationModal.js';
import Alert from '../Assets/Alerts.js';



const ViewCompanies = () => {
    const [companies, setCompanies] = useState([]);
    const [logo, setLogo] = useState(null);
    const [loader, setLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ company_name: '', company_logo: null });
    const [modalTitle, setModalTitle] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [alert, setAlert] = useState('');

    const fetchData = useCallback(async () => {
        setLoader(true);
        const response = await getData('companies');
        setCompanies(response.data.data)
        generateSerialNo(response.data.data);
        setLoader(false);
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        if (alert.message) {
            const timer = setTimeout(() => {
                setAlert({ type: '', message: '' });
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [alert]);



    const generateSerialNo = (companies) => {
        let serialNo = 1;
        return companies.map(user => {
            user.serial_no = serialNo;
            serialNo++;
            return companies;
        });
    }

    const hotTableRef = useRef(null);


    const actionRenderer = (_instance, td, row, _col, _prop, value, _cellProperties) => {
        // Clear the cell before adding custom content
        Handsontable.dom.empty(td);

        // Create "Edit" button
        const editButton = document.createElement("i");
        editButton.innerHTML = "<span class='action-icons'>Edit</span>";
        editButton.className = "fa fa-pencil mx-2 ft-6 text-primary";
        editButton.onclick = () => handleOpenModal(value, true);

        // Create "Delete" button
        const deleteButton = document.createElement("i");
        deleteButton.innerHTML = "<span class='action-icons'>Delete</span>";
        deleteButton.className = "fa fa-trash mx-2 ft-6 text-danger";
        deleteButton.onclick = () => handleDelete(row);

        // Append buttons to the cell
        td.appendChild(editButton);
        td.appendChild(deleteButton);
        td.className = "d-flex justify-content-between align-items-center";

        return td;
    };

    const handleOpenModal = async (value, isEdit) => {
        if (isEdit) {
            const response = await getData(`companies/${value}`);
            setFormData({ company_name: response?.data?.data?.company_name, company_logo: response?.data?.data?.company_logo });
            setSelectedRow(response?.data?.data?.company_id);
            setModalTitle('Edit Company');
            setShowModal(true);
            setIsEdit(true);
        }

        else {
            setFormData({ company_name: "", company_logo: null });
            setModalTitle('Add Company');
            setIsEdit(false);
            setShowModal(true);
        }
    };

    const handleDelete = (row) => {
        if (hotTableRef.current?.hotInstance) {
            const rowData = hotTableRef.current.hotInstance.getDataAtRow(row);
            setSelectedRow(rowData[2]); // Assuming sub_event_id is at index 2
            setShowConfirmationModal(true);
        } else {
            console.error("hotTableRef is not initialized");
        }
    };

    const confirmDelete = async () => {
        if (selectedRow) {
            const response = await deleteData(`companies/${selectedRow}`);
            if (response) {
                fetchData();
            }
            setShowConfirmationModal(false);
            setSelectedRow(null);
        }
    };

    const handleSubmit = async (submittedData = {}) => {
        const form = new FormData();
        form.append('company_name', submittedData?.company_name ?? formData?.company_name ?? '');
        if (logo) form.append('company_logo', logo);

        try {
            let response;
            if (isEdit) {
                response = await putFile(`companies/${selectedRow}`, form);
            } else {
                response = await postFile('companies', form);
            }

            if (response.error) {
                setAlert({ type: 'error', message: response.error.message });
            } else {
                setAlert({ type: 'success', message: response.data.message });
                handleCloseModal();
            }
        } catch (error) {
            console.error(error);
            setAlert({ type: 'error', message: error.message });
        }
    };

    const handleLogoChange = useCallback((file) => {
        setLogo(file);
    }, []);

    const fields = [
        {
            name: 'company_name',
            label: 'Company Name',
            value: formData?.company_name,
            type: 'text',
            required: true,
            placeholder: 'Enter Company Name'
        },
        {
            name: 'company_logo',
            label: 'Company Logo',
            type: 'file',
            onChange: handleLogoChange,
            view: { label: 'Company Logo : ', value: formData?.company_logo }
        }
    ];

    const handleCloseModal = () => {
        setShowModal(false);
        fetchData();
    };

    const button = <button className="btn-success btn btn-sm" onClick={() => handleOpenModal(null, false)}>Add Company</button>;



    return (
        <>
            {loader && <Loader />}
            {alert.message && <Alert type={alert.type} message={alert.message} />}
            {showModal && <FormModal showModal={showModal} setShowModal={setShowModal} title={modalTitle} fields={fields} handleSubmit={handleSubmit} />}
            {showConfirmationModal && <ConfirmationModal showModal={showConfirmationModal} setShowModal={setShowConfirmationModal} title="Delete Company" message="Are you sure you want to delete this company?" onConfirm={confirmDelete} />}
            <Header title="Companies" button={button} />
            <div className="container-fluid">
                <div className="row justify-content-center" >
                    {/* <div className="col-12 d-flex justify-content-end my-2"> */}
                    {/* <div className="col-4 position-relative"><input type="search" className="form-control border-1 border-secondary-emphasis form-control-sm " placeholder='Search' />
                            <FontAwesomeIcon className="position-absolute top-0 end-0 mt-2 me-2 fs-6 icon-success" icon={faSearch} />
                        </div> */}


                    {/* </div> */}
                    <div className="col-12 listing-view">
                        <HotTable
                            ref={hotTableRef}
                            data={companies}

                            columns={[
                                { data: 'serial_no', title: 'Sr. No.', type: 'text', dropdownMenu: false, width: 10, },
                                { title: 'Company Name', type: 'text', data: 'company_name' },
                                { title: 'Action', type: 'text', data: 'company_id', renderer: actionRenderer, enableHtml: true, dropdownMenu: false, width: 22 },
                            ]}
                            filters={true}
                            dropdownMenu={true}
                            manualColumnResize={true}
                            manualColumnMove={true}
                            manualRowMove={true}
                            readOnly={true}
                            autoWrapRow={true}
                            autoWrapCol={true}
                            className='htBold'

                            licenseKey={process.env.REACT_APP_EXCEL_LICENSE_KEY}
                        />

                    </div>
                </div>

            </div>
        </>
    )
}

export default ViewCompanies
